<template>
    <div>
        <vs-popup title="Importar Base de Produtos" 
          :active.sync="isActive"
          @close="$emit('isActiveFalse')"
          style="border-radius: 10px !important; z-index: 999;"
          class="sizePopup"
        >
            <div>
                <span><strong>Inserir Base</strong></span>
                <p>
                  Selecione uma planilha no <strong>formato XLSX</strong> com todos os seus produtos para que
                  possamos realizar uma importação.
                </p>
                <p>
                  É obrigatório que a planilha possua colunas referentes aos campos "nome", "preço", "categoria"
                  e "código de barras" do produto.
                </p>
                <import-excel
                  :action="uploadApiUrl"
                  fileName="file"
                  :headers="{
                      Authorization: 'Bearer ' + bearer
                  }"
                  :onSuccess="loadDataInTable"
                  @on-success="successUploadSheet"
                  @on-error="errorUploadSheet"
                  :maxRowsToImport="100000"
                  confirmMessage="Para que seu uso não seja prejudicado, limitamos o máximo de produtos permitidos para 100.000. Obrigado!"
                  class="mt-2"
                />
            
                <vs-button
                color="danger"
                @click="removeSheet"
                class="mt-2"
                :disabled="!this.sheetUrl"
                >
                    Remover Planilha Importada
                </vs-button>
            </div>
                        
        </vs-popup>

        <vs-popup
         class="basePopUp"
         @close="removeSheet"
         :active.sync="popupSheetActivated"
         > 
            <div class="mb-4">
                <span class="display-span-products">
                    <p class="ml-6" style="font-size: 16px;">
                    Nome
                    </p>
                    <div class="flex-end-align">
                        <vs-icon @click="removeSheet" icon="close" style="-webkit-transform: scaleX(-1); transform: scaleX(-1); float: right; cursor:pointer;"></vs-icon>
                    </div>
                </span>
            </div>
            <p class="float-left"> Selecione a coluna correspondente ao <b>nome</b> do produto </p> <br>
            <div class="flex text-center justify-center items-start mt-3 mb-3" 
                style="border: 1px solid rgba(0, 0, 0, 0.2); border-radius: 10px;"
            >
                <!-- Nome do Produto -->
                <div class="mt-2 ml-2 flex justify-center items-center" style="flex-direction: column;">
                <strong>Nome</strong>
                <vs-table
                    :data="header"
                    v-model="name_sheet"
                >
                    <template slot-scope="{data}">
                    <vs-tr :key="key" v-for="(head, key) in header" :data="head">
                        <vs-td :data="head">
                        {{head}}
                        </vs-td>
                    </vs-tr>
                    </template>
                </vs-table>
                </div>
            </div>

            <div class="float-right"> 
            <vs-button
                color="danger"
                type="filled"
                class="mr-2"
                @click.prevent="removeSheet()"
            >
                <span>Cancelar</span>
            </vs-button>

            <vs-button
                color="rgb(62, 201, 214)"
                type="filled"
                @click="openPricePopUp"
            >
                <span>Próximo</span>
            </vs-button>
            </div>
      </vs-popup>

        <!-- Modal Preço -->
        <vs-popup
         class="basePopUp"
         @close="removeSheet"
         hide-header="true"
         :active.sync="pricePopUp"
         > 
           <div class="mb-4">
                <span class="display-span-products">
                    <vs-icon
                        icon="keyboard_arrow_left"
                        style="border: solid 1px; border-radius: 14px; cursor: pointer;"
                        @click="backToProductName"
                    />
                    <p class="ml-3" style="font-size: 16px;">
                    Preço
                    </p>
                    <div class="flex-end-align">
                        <vs-icon @click="removeSheet" icon="close" style="-webkit-transform: scaleX(-1); transform: scaleX(-1); float: right; cursor:pointer;"></vs-icon>
                    </div>
                </span>
            </div>

            <p class="float-left"> Selecione a coluna correspondente ao <b>preço</b> do produto </p> <br>
            <div class="flex text-center justify-center items-start mt-3 mb-3" 
                style="border: 1px solid rgba(0, 0, 0, 0.2); border-radius: 10px;"
            >
                
                <div class="mt-2 ml-2 flex justify-center items-center" style="flex-direction: column;">
                <strong>Preço</strong>
                <vs-table
                    :data="header"
                    v-model="price_sheet"
                >
                    <template slot-scope="{data}">
                    <vs-tr :key="key" v-for="(head, key) in header" :data="head">
                        <vs-td :data="head">
                        {{head}}
                        </vs-td>
                    </vs-tr>
                    </template>
                </vs-table>
                </div>
            </div>

            <div class="float-right"> 
            <vs-button
                color="danger"
                type="filled"
                class="mr-2"
                @click.prevent="removeSheet()"
            >
                <span>Cancelar</span>
            </vs-button>

            <vs-button
                color="rgb(62, 201, 214)"
                type="filled"
                @click="openCategoryPopUp"
            >
                <span>Próximo</span>
            </vs-button>
            </div>
        </vs-popup>

        <!-- Modal Categoria -->
        <vs-popup
         class="basePopUp"
         @close="removeSheet"
         hide-header="true"
         :active.sync="categoryPopUp"
         > 
           <div class="mb-4">
                <span class="display-span-products">
                    <vs-icon
                        icon="keyboard_arrow_left"
                        style="border: solid 1px; border-radius: 14px; cursor: pointer;"
                        @click="backToPrice"
                    />
                    <p class="ml-3" style="font-size: 16px;">
                    Categoria
                    </p>
                    <div class="flex-end-align">
                        <vs-icon @click="removeSheet" icon="close" style="-webkit-transform: scaleX(-1); transform: scaleX(-1); float: right; cursor:pointer;"></vs-icon>
                    </div>
                </span>
            </div>

            <p class="float-left"> Selecione a coluna correspondente a <b>categoria</b> do produto </p> <br>
            <div class="flex text-center justify-center items-start mt-3 mb-3" 
                style="border: 1px solid rgba(0, 0, 0, 0.2); border-radius: 10px;"
            >
                
                <div class="mt-2 ml-2 flex justify-center items-center" style="flex-direction: column;">
                <strong>Categoria</strong>
                <vs-table
                    :data="header"
                    v-model="category_sheet"
                >
                    <template slot-scope="{data}">
                    <vs-tr :key="key" v-for="(head, key) in header" :data="head">
                        <vs-td :data="head">
                        {{head}}
                        </vs-td>
                    </vs-tr>
                    </template>
                </vs-table>
                </div>
            </div>

            <div class="float-right"> 
            <vs-button
                color="danger"
                type="filled"
                class="mr-2"
                @click.prevent="removeSheet()"
            >
                <span>Cancelar</span>
            </vs-button>

            <vs-button
                color="rgb(62, 201, 214)"
                type="filled"
                @click="openBarCodePopUp"
            >
                <span>Próximo</span>
            </vs-button>
            </div>
        </vs-popup>

        <!-- Modal Codigo de Barras -->
        <vs-popup
         class="basePopUp"
         @close="removeSheet"
         hide-header="true"
         :active.sync="barCodePopUp"
         > 
           <div class="mb-4">
                <span class="display-span-products">
                    <vs-icon
                        icon="keyboard_arrow_left"
                        style="border: solid 1px; border-radius: 14px; cursor: pointer;"
                        @click="backToCategory"
                    />
                    <p class="ml-3" style="font-size: 16px; width: 205px;">
                    Código de Barras
                    </p>
                    <div class="flex-end-align">
                        <vs-icon @click="removeSheet" icon="close" style="-webkit-transform: scaleX(-1); transform: scaleX(-1); float: right; cursor:pointer;"></vs-icon>
                    </div>
                </span>
            </div>

            <p class="float-left"> Selecione a coluna correspondente ao <b>código de barras</b> do produto </p> <br>
            <div class="flex text-center justify-center items-start mt-3 mb-3" 
                style="border: 1px solid rgba(0, 0, 0, 0.2); border-radius: 10px;"
            >
                
                <div class="mt-2 ml-2 flex justify-center items-center" style="flex-direction: column;">
                <strong>Código de Barras</strong>
                <vs-table
                    :data="header"
                    v-model="bar_code_sheet"
                >
                    <template slot-scope="{data}">
                    <vs-tr :key="key" v-for="(head, key) in header" :data="head">
                        <vs-td :data="head">
                        {{head}}
                        </vs-td>
                    </vs-tr>
                    </template>
                </vs-table>
                </div>
            </div>

            <div class="float-right"> 
            <vs-button
                color="danger"
                type="filled"
                class="mr-2"
                @click.prevent="removeSheet()"
            >
                <span>Cancelar</span>
            </vs-button>

            <vs-button
                color="rgb(62, 201, 214)"
                type="filled"
                @click="openBrandPopUp"
            >
                <span>Próximo</span>
            </vs-button>
            </div>
        </vs-popup>

        <!-- Modal Marca -->
        <vs-popup
         class="basePopUp"
         @close="removeSheet"
         hide-header="true"
         :active.sync="brandPopUp"
         > 
           <div class="mb-4">
                <span class="display-span-products">
                    <vs-icon
                        icon="keyboard_arrow_left"
                        style="border: solid 1px; border-radius: 14px; cursor: pointer;"
                        @click="backToBarCode"
                    />
                    <p class="ml-3" style="font-size: 16px; width: 280px;">
                    Marca do produto 
                    </p>
                    <span>(opcional)</span>
                    <div class="flex-end-align">
                        <vs-icon @click="removeSheet" icon="close" style="-webkit-transform: scaleX(-1); transform: scaleX(-1); float: right; cursor:pointer;"></vs-icon>
                    </div>
                </span>
            </div>

            <p class="float-left"> Selecione a coluna correspondente a <b>marca</b> do produto </p> <br>
            <div class="flex text-center justify-center items-start mt-3 mb-3" 
                style="border: 1px solid rgba(0, 0, 0, 0.2); border-radius: 10px;"
            >
                
                <div class="mt-2 ml-2 flex justify-center items-center" style="flex-direction: column;">
                <strong>Marca do Produto</strong>
                <vs-table
                    :data="header"
                    v-model="brand_sheet"
                >
                    <template slot-scope="{data}">
                    <vs-tr :key="key" v-for="(head, key) in header" :data="head">
                        <vs-td :data="head">
                        {{head}}
                        </vs-td>
                    </vs-tr>
                    </template>
                </vs-table>
                </div>
            </div>

            <div class="float-right"> 
            <vs-button
                color="danger"
                type="filled"
                class="mr-2"
                @click.prevent="removeSheet()"
            >
                <span>Cancelar</span>
            </vs-button>

            <vs-button
                color="rgb(62, 201, 214)"
                type="filled"
                @click="openActivePrincipleUp"
            >
                <span>Próximo</span>
            </vs-button>
            </div>
        </vs-popup>

        <!-- Modal Principio Ativo -->
        <vs-popup
         class="basePopUp"
         @close="removeSheet"
         hide-header="true"
         :active.sync="activePrinciplePopUp"
         > 
           <div class="mb-4">
                <span class="display-span-products">
                    <vs-icon
                        icon="keyboard_arrow_left"
                        style="border: solid 1px; border-radius: 14px; cursor: pointer;"
                        @click="backToBrand"
                    />
                    <p class="ml-3" style="font-size: 16px; width: 210px;">
                    Principio Ativo 
                    </p>
                    <span>(opcional)</span>
                    <div class="flex-end-align">
                        <vs-icon @click="removeSheet" icon="close" style="-webkit-transform: scaleX(-1); transform: scaleX(-1); float: right; cursor:pointer;"></vs-icon>
                    </div>
                </span>
            </div>

            <p class="float-left"> Selecione a coluna correspondente ao <b>principio ativo</b> do produto </p> <br>
            <div class="flex text-center justify-center items-start mt-3 mb-3" 
                style="border: 1px solid rgba(0, 0, 0, 0.2); border-radius: 10px;"
            >
                
                <div class="mt-2 ml-2 flex justify-center items-center" style="flex-direction: column;">
                <strong>Principio Ativo</strong>
                <vs-table
                    :data="header"
                    v-model="active_principle_sheet"
                >
                    <template slot-scope="{data}">
                    <vs-tr :key="key" v-for="(head, key) in header" :data="head">
                        <vs-td :data="head">
                        {{head}}
                        </vs-td>
                    </vs-tr>
                    </template>
                </vs-table>
                </div>
            </div>

            <div class="float-right"> 
            <vs-button
                color="danger"
                type="filled"
                class="mr-2"
                @click.prevent="removeSheet()"
            >
                <span>Cancelar</span>
            </vs-button>

            <vs-button
                color="rgb(62, 201, 214)"
                type="filled"
                @click="openDescriptionUp"
            >
                <span>Próximo</span>
            </vs-button>
            </div>
        </vs-popup>

        <!-- Modal Descrição -->
        <vs-popup
         class="basePopUp"
         @close="removeSheet"
         hide-header="true"
         :active.sync="descriptionPopUp"
         > 
           <div class="mb-4">
                <span class="display-span-products">
                    <vs-icon
                        icon="keyboard_arrow_left"
                        style="border: solid 1px; border-radius: 14px; cursor: pointer;"
                        @click="backToActivePrinciple"
                    />
                    <p class="ml-3" style="font-size: 16px; width: 110px;">
                    Descrição 
                    </p>
                    <span> (opcional)</span>
                    <div class="flex-end-align">
                        <vs-icon @click="removeSheet" icon="close" style="-webkit-transform: scaleX(-1); transform: scaleX(-1); float: right; cursor:pointer;"></vs-icon>
                    </div>
                </span>
            </div>

            <p class="float-left"> Selecione a coluna correspondente a <b>descrição</b> do produto </p> <br>
            <div class="flex text-center justify-center items-start mt-3 mb-3" 
                style="border: 1px solid rgba(0, 0, 0, 0.2); border-radius: 10px;"
            >
                
                <div class="mt-2 ml-2 flex justify-center items-center" style="flex-direction: column;">
                <strong>Descrição</strong>
                <vs-table
                    :data="header"
                    v-model="description_sheet"
                >
                    <template slot-scope="{data}">
                    <vs-tr :key="key" v-for="(head, key) in header" :data="head">
                        <vs-td :data="head">
                        {{head}}
                        </vs-td>
                    </vs-tr>
                    </template>
                </vs-table>
                </div>
            </div>

            <div class="float-right"> 
            <vs-button
                color="danger"
                type="filled"
                class="mr-2"
                @click.prevent="removeSheet()"
            >
                <span>Cancelar</span>
            </vs-button>

            <vs-button
            color="rgb(62, 201, 214)"
            type="filled"
            @click="openLaboratoryPopUp()"
            >
                <span>Próximo</span>
            </vs-button>
            </div>
        </vs-popup>

        <!-- Modal Laboratório -->
        <vs-popup
         class="basePopUp"
         @close="removeSheet"
         hide-header="true"
         :active.sync="laboratoryPopUp"
         > 
           <div class="mb-4">
                <span class="display-span-products">
                    <vs-icon
                        icon="keyboard_arrow_left"
                        style="border: solid 1px; border-radius: 14px; cursor: pointer;"
                        @click="backToDescription"
                    />
                    <p class="ml-3" style="font-size: 16px; width: 110px;">
                    Laboratório 
                    </p>
                    <span>  (opcional) </span>
                    <div class="flex-end-align">
                        <vs-icon @click="removeSheet" icon="close" style="-webkit-transform: scaleX(-1); transform: scaleX(-1); float: right; cursor:pointer;"></vs-icon>
                    </div>
                </span>
            </div>

            <p class="float-left"> Selecione a coluna correspondente a <b>laboratório</b> do produto </p> <br>
            <div class="flex text-center justify-center items-start mt-3 mb-3" 
                style="border: 1px solid rgba(0, 0, 0, 0.2); border-radius: 10px;"
            >
                
                <div class="mt-2 ml-2 flex justify-center items-center" style="flex-direction: column;">
                <strong>Laboratório</strong>
                <vs-table
                    :data="header"
                    v-model="laboratory_sheet"
                >
                    <template slot-scope="{data}">
                    <vs-tr :key="key" v-for="(head, key) in header" :data="head">
                        <vs-td :data="head">
                        {{head}}
                        </vs-td>
                    </vs-tr>
                    </template>
                </vs-table>
                </div>
            </div>

            <div class="float-right"> 
            <vs-button
                color="danger"
                type="filled"
                class="mr-2"
                @click.prevent="removeSheet()"
            >
                <span>Cancelar</span>
            </vs-button>

            <vs-button
                color="rgb(62, 201, 214)"
                type="filled"
                @click="sendData"
            >
                <span>Finalizar</span>
            </vs-button>
            </div>
        </vs-popup>

    </div>
    
</template>

<script>
    import Upload from '@/components/upload/Upload'
    import ImportExcel from "@/components/excel/ImportExcel"
    import { removeFileFromBucket } from '@/utils'
    import productApi from '@/http/requests/product'

    export default {
        name: 'ImportProductModal',
        components: {
            Upload,
            ImportExcel,
        },
        data() {
            return {
                results: [],
                popupSheetActivated: false,
                pricePopUp: false,
                categoryPopUp: false,
                barCodePopUp: false, 
                brandPopUp: false,
                activePrinciplePopUp: false,
                descriptionPopUp: false,
                laboratoryPopUp: false,
                product_sheet: null,
                price_sheet: null,
                category_sheet: null,
                brand_sheet: null,
                bar_code_sheet: null,
                active_principle_sheet: null,
                description_sheet: null,
                laboratory_sheet: null,
                header: [],
                name_sheet: null,
                sheetUrl: null
            }
        },
        props: {
            isActive: {
                type: Boolean,
                required: true
            }
        },
        emits: [
            'isActiveFalse'
        ],
        methods: {
            removeSheet() {
                this.popupSheetActivated = false;
                this.pricePopUp = false;
                this.categoryPopUp = false;
                this.barCodePopUp = false;
                this.brandPopUp = false;
                this.activePrinciplePopUp = false;
                this.descriptionPopUp = false;
                this.laboratoryPopUp = false;
                

                this.product_sheet = null;
                this.name_sheet = null;
                this.price_sheet = null;
                this.category_sheet = null;
                this.brand_sheet = null;
                this.bar_code_sheet = null;
                this.active_principle_sheet = null;
                this.description_sheet = null;
                this.laboratory_sheet = null;
                this.sheetUrl = null
            },
            successUploadSheet(response) {
                this.$vs.notify({
                    color: 'success',
                    title: 'Planilha carregada com sucesso!',
                    text: response.data.message
                })

                this.sheetUrl = response.data.fileUrl
            },
            errorUploadSheet(response) {
                this.removeSheet()
                this.$vs.notify({
                color: 'danger',
                title: 'Ocorreu um erro ao subir a planilha!',
                text: response.data.message
                })
            },
            loadDataInTable({ results, header, meta }) {
                this.$emit('isActiveFalse');
                console.log(results)
                this.popupSheetActivated = true;
                this.results = results

                this.header = header

                this.sheetName = meta.sheetName

            },
            openPricePopUp() {

                if (this.name_sheet !== null) {
                    this.popupSheetActivated = false;
                    this.pricePopUp = true;
                }
                else {
                    this.$vs.notify({
                        color: 'danger',
                        title: 'Campo obrigatório',
                        text: 'Por favor selecione o campo correspondente ao nome do produto'
                    })
                }
            },
            backToProductName() {
                this.popupSheetActivated = true;
                this.pricePopUp = false;
            },
            openCategoryPopUp() {
                if (this.price_sheet !== null) {
                    this.pricePopUp = false;
                    this.categoryPopUp = true;
                }
                else {
                    this.$vs.notify({
                        color: 'danger',
                        title: 'Campo obrigatório',
                        text: 'Por favor selecione o campo correspondente ao preço do produto'
                    })
                }
                
            },
            backToPrice() {
                this.categoryPopUp = false;
                this.pricePopUp = true;
            },
            openBarCodePopUp() {
                if (this.category_sheet !== null) {
                    this.barCodePopUp = true;
                    this.categoryPopUp = false;
                }
                else {
                    this.$vs.notify({
                        color: 'danger',
                        title: 'Campo obrigatório',
                        text: 'Por favor selecione o campo correspondente a categoria do produto'
                    })
                }
            },
            backToCategory() {
                this.categoryPopUp = true;
                this.barCodePopUp = false;
            },
            openBrandPopUp() {
                this.barCodePopUp = false;
                this.brandPopUp = true;
            },
            backToBarCode() {
                this.barCodePopUp = true;
                this.brandPopUp = false;
            },
            openActivePrincipleUp() {
                this.activePrinciplePopUp = true;
                this.brandPopUp = false;
            },
            backToBrand() {
                this.activePrinciplePopUp = false;
                this.brandPopUp = true;
            },
            openDescriptionUp() {
                this.activePrinciplePopUp = false;
                this.descriptionPopUp = true;
            },
            backToActivePrinciple() {
                this.activePrinciplePopUp = true;
                this.descriptionPopUp = false;
            },
            openLaboratoryPopUp() {
                this.descriptionPopUp = false;
                this.laboratoryPopUp  = true;
            },
            backToDescription() {
                this.laboratoryPopUp  = false; 
                this.descriptionPopUp = true;
            },
            sendData() {
                let dataToSend = {
                    sheet_url: this.sheetUrl,
                    name_sheet_column: this.name_sheet,
                    price_sheet_column: this.price_sheet,
                    category_sheet_column: this.category_sheet,
                    bar_code_sheet_column: this.bar_code_sheet,
                    brand_sheet_column: this.brand_sheet,
                    active_principle_sheet_column: this.active_principle_sheet,
                    description_sheet_column: this.description_sheet,
                    laboratory_sheet_column: this.laboratory_sheet
                };

                productApi.importProducts(dataToSend)
                    .then(() => {
                        this.removeSheet();

                        return this.$vs.notify({
                            color: 'success',
                            title: 'A importação será feita:',
                            text: 'Os produtos serão importados!'
                        });
                    })
                    .catch((exception) => {
                        console.log(exception);

                        return this.$vs.notify({
                            color: 'danger',
                            title: 'Houve algum erro ao importar os produtos!'
                        });
                    });
            
            }
        },
        computed: {
            uploadApiUrl() {
                return localStorage.getItem('baseUrl') + '/api/file/upload'
            },
            bearer() {
                return this.$store.state.auth.bearer
            },
        },
        watch: {
            'this.sheetUrl': function(_, oldValue) {
                if (oldValue) {
                    removeFileFromBucket(oldValue);
                }
            },
        }
    }
</script>

<style lang="scss">

    .basePopUp div.vs-popup {
        .vs-popup--header {
            background-color: transparent !important;
            display: none;
        }
        header {
            background-color: transparent !important;
        }
    }
    .display-span-products {
        display: flex;
        justify-content: flex-start;
        flex-direction: row;
        align-items: center;
        div {
            display: flex;
            justify-content: flex-end;
            width: 100%;
            i.vs-icon.notranslate.icon-scale.mr-2.material-icons.null:last-of-type {
                cursor: pointer;
            }
        }
    }
</style>
